/**
 * Product feedback env + master enable (D8 / D12).
 * Question ids live in surveyQuestionIds.ts.
 * Admin Settings (`system_settings.product_feedback_enabled`) ANDs with env.
 * No end-user opt-out (D7).
 */

function trimOrEmpty(value: string | undefined): string {
  return typeof value === "string" ? value.trim() : "";
}

/** Env deploy kill-switch. Default on when unset (missing survey id still gates capture). */
export function isProductFeedbackEnvEnabled(): boolean {
  const raw = process.env.NEXT_PUBLIC_PRODUCT_FEEDBACK_ENABLED;
  if (raw === undefined || raw === "") return true;
  const normalized = raw.trim().toLowerCase();
  return normalized !== "false" && normalized !== "0" && normalized !== "off";
}

/**
 * Latest Admin Settings value mirrored from SystemSettingsContext.
 * `null` = not loaded yet → treat as on (DB default true).
 */
let adminProductFeedbackEnabled: boolean | null = null;

/** Called from Help chrome / settings consumers when public settings load. */
export function setProductFeedbackAdminEnabled(enabled: boolean): void {
  adminProductFeedbackEnabled = enabled;
}

export function getProductFeedbackAdminEnabled(): boolean {
  return adminProductFeedbackEnabled ?? true;
}

/** D12 master: env AND Admin Settings. */
export function isProductFeedbackMasterEnabled(): boolean {
  return isProductFeedbackEnvEnabled() && getProductFeedbackAdminEnabled();
}

export function getProductFeedbackSurveyId(): string {
  return trimOrEmpty(process.env.NEXT_PUBLIC_PRODUCT_FEEDBACK_SURVEY_ID);
}

export function hasProductFeedbackSurveyId(): boolean {
  return getProductFeedbackSurveyId().length > 0;
}
